import {
  Grid,
  Typography
} from "@mui/material";
import { translationService } from "e.sic-platform.webclient/src/services/translation/TranslationService";
import { observer } from "mobx-react-lite";
import { createContext, useContext, useState } from "react";

export interface ISmartApp {
  titleKey?: string;
  descriptionKey?: string;
  image?: string;
  children: any;
}

const SmartAppContext = createContext<
  | {
      step: number;
      setStep: (id: number) => void;
      confirmationPending: boolean;
      setConfirmationPending: (confirmation: boolean) => void;
    }
  | undefined
>(undefined);

export function useSmartApps() {
  const context = useContext(SmartAppContext);
  if (context === undefined) throw new Error("Service has no provider");
  return context;
}

export default observer(function SmartApp(props: ISmartApp) {
  const { titleKey = "", descriptionKey = "", image } = props;

  const [step, setStep] = useState(1);
  const [confirmationPending, setConfirmationPending] = useState(false);

  return (
    <SmartAppContext.Provider
      value={{
        step,
        setStep,
        confirmationPending,
        setConfirmationPending,
      }}
    >
      <Grid container xs={12} sx={{p: 2}}>
      <Grid item xs={3} className="centered">
          {image && (
            <img
              src={image}
              height={300}
              style={{ maxWidth: "100%", marginTop: 4 }}
            />
          )}
        </Grid>
        <Grid container xs={9}>
          <Grid item xs={12}>
            <Typography variant="h4" sx={{ marginBottom: 2 }}>
              {translationService.translate(titleKey)}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Grid item xs={6}>
              <Typography
                align="left"
                variant="body1"
                color="GrayText"
                sx={{ marginBottom: 3, lineHeight: 3 }}
              >
                {translationService.translate(descriptionKey)}
              </Typography>
            </Grid>
          </Grid>
        </Grid>
        <Grid container rowSpacing={2} sx={{mt: 2}}>
          {props.children}
        </Grid>
      </Grid>
    </SmartAppContext.Provider>
  );
});
